import * as React from "react";
const MenuSubmenuRootContext = /* @__PURE__ */ React.createContext(void 0);
if (process.env.NODE_ENV !== "production") MenuSubmenuRootContext.displayName = "MenuSubmenuRootContext";
function useMenuSubmenuRootContext() {
  return React.useContext(MenuSubmenuRootContext);
}
export {
  MenuSubmenuRootContext,
  useMenuSubmenuRootContext
};
//# sourceMappingURL=MenuSubmenuRootContext.js.map
